<template>
<el-container class="container-editor is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
    <template slot="left">
      <div style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
          <el-breadcrumb-item :to="{ path: '/contentTemplate' }">內容範本列表</el-breadcrumb-item>
          <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </template>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">

      <div class="header">
        <el-button type="primary" class="btn-upload" size="mini" @click="submit">送出<i class="el-icon-upload el-icon--right"></i></el-button>
      </div>

      <el-form label-width="120px" @submit.native.prevent>

        <div>
          <el-form-item label="名稱">
            <el-input v-model="form.Name"></el-input>
          </el-form-item>
        </div>

        <div style="padding-left: 120px;">

          <el-divider>
          </el-divider>

          <content-editor v-model="form.contentJsonArr"/>
        </div>

      </el-form>

    </el-main>
  </el-container>
</el-container>
</template>

<script>
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import ContentEditor from '@/utils/content-editor/components/ContentEditor.vue'
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'

export default {
  mixins: [MixinOfPreventLeaveEditPage],
  components: {
    LeftMenu, TopHeader, ContentEditor
  },
  data () {
    return {
      oriObj: {},
      form: {},
      isLoading: false
    }
  },
  computed: {
    isEdit () {
      return this.$route.name !== 'createContentTemplate'
    },
    title () {
      return this.isEdit ? this.oriObj.Name : '新增'
    }
  },
  methods: {
    submit () {
      if (!this.validateInput()) { return }
      this.isLoading = true
      // 處理資料
      this.form.Contents = JSON.stringify(this.form.contentJsonArr)

      let promise = this.isEdit ? this.$services.contentTemplate.edit(this, this.form) : this.$services.contentTemplate.add(this, this.form)
      promise.then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.onObjAddedit(res)
      })
        .catch(this.$handleServiceError)
        .finally(() => {
          this.isLoading = false
        })
    },
    onObjAddedit (res) {
      localStorage.removeItem(this.cacheKey)
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = {}
      this.$router.push({ name: 'contentTemplate-list' })
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.contentTemplate.list.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.contentTemplate.list.findIndex(o => o.ID === newObj.ID)
        if (idx >= 0) {
          this.$set(this.$store.state.contentTemplate.list, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown contentTemplate for id ${newObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null
      if (!this.form.Name) {
        errMsg = '請輸入內容範本名稱'
      } else if (!this.form.contentJsonArr || !this.form.contentJsonArr.length) {
        errMsg = '請輸入內容範本'
      }
      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    }
  },
  created () {
    let id = parseInt(this.$route.params.id)
    if (id && id > 0) {
      let idx = this.$store.state.contentTemplate.list.findIndex(o => o.ID === id)
      if (idx >= 0) {
        this.oriObj = this.$store.state.contentTemplate.list[idx]
        this.form = JSON.parse(JSON.stringify(this.oriObj))

        // 處理資料
        this.form.contentJsonArr = JSON.parse(this.form.Contents)
      } else {
        console.error(`unknown contentTemplate for id ${id}`)
      }
    }
  }
}
</script>

<style>
.header {
  height: 40px;
}

.el-form {
  max-width: 1030px;
}
</style>
